export function CheckboxUncheckedIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_133_23993)">
        <rect x="1" y="1" width="18" height="18" rx="4" stroke="#98A2B3" stroke-width="1.67" />
      </g>
      <defs>
        <clipPath id="clip0_133_23993">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "CheckboxUncheckedIcon";
